window._ = require('lodash');
window.$ = window.jQuery = require('jquery');

require('bootstrap');

// Axios
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Base64
window.Base64 = require('js-base64');

// Daterangepicker
window.daterangepicker = require('../../node_modules/daterangepicker/daterangepicker');
require('./daterangepicker_locales');

// Select2
require('../../node_modules/select2/dist/js/select2.full');

// Autonumeric
window.Autonumeric = require('autonumeric');

// Theme
require('./theme');

// Custom
require('./custom');

// Vue components
require('./vue');
